import { IconButton, Tooltip, Typography } from "@mui/material";
import { CommonService } from "../../Service/CommonService";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Spinner from "../Common/Spinner";
import { useParams, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { SupportApiService } from "../../Service/SupportApiService";
import CreatableSelect from 'react-select/creatable';
import useFormValidation from "./FormValidation";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { Service } from "../../Service/ApiService";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import ScannedWarning from "../../assets/images/icons/ScannedWarning.svg";
import InfoIcon from '../../assets/images/icons/Info.svg'

const DEFAULT_MASH_BILL = "00% Corn, 00% Rye, 00% Wheat, 00% Malted Barley";

const EditLotDetails = () => {
    const { id } = useParams<{ id: string }>();
    const history = useHistory();
    const routeBack = () => {history.goBack();};
    const [isLoading, setIsLoading] = useState(false);
    const [facilities, setFacilities] = useState<string[]>([]);
    const [error, setError] = useState<string>("");
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const facilityOptions = facilities.map((f: any) => ({value: f.id, label: f.facilityName}));
    const [BarrelLotData, setBarrelLotData] = useState<any>({});
    const {formData, errors, handleChange, handleBlur, setErrors, validateForm, setFormData} = useFormValidation(BarrelLotData);
    const handleClose = () => {setShow(false); setError("")};
    const [updateScope, setUpdateScope] = useState<"whole_lot" | "matching_only">("whole_lot");
    const isDirty = React.useMemo(() => {
        const watchedFields = ["productName", "producer", "dsp", "mashBill", "proof", "proofGallons",
            "ttbType", "ttbClass", "barrelCost", "totalLotPg", "containerCooperage",
            "description", "isShipped", "mashBillDescription", "isManagedByWhitedog"];
        return watchedFields.some((field) => formData[field] !== BarrelLotData[field]);
    }, [formData, BarrelLotData]);

    useEffect(() => {
        getBarrelLotLevelList();
        fetchFacilityList();
    }, []);

    const stripHtml = (html = "") => (html ?? "").replace(/<\/?[^>]+(>|$)/g, "");

        const validateRequireFields = () => {

        let isValidationPass = true;

        const requiredFields = [
            { field: "productName", error: "Please nter Product Name" },  
            { field: "producer", error: "Please enter Producer" },
            { field: "dsp", error: "Please enter DSP" },
            { field: "facility", error: "Please enter Facility" },
            { field: "mashBill", error: "Please enter Mash Bill" }
        ];

        requiredFields.forEach(({ field, error }) => {
        if (formData[field]?.length === 0 || errors[field]) {
            if (formData[field]?.length === 0) {
            setErrors((prevState) => ({ ...prevState, [field]: error }));
            }
            isValidationPass = false;
        }
        });

        return isValidationPass;
    }

    const getBarrelLotLevelList = async () => {
        try {
            const response = await InventoryApiService.getBarrelLotLevelList(id);
            setBarrelLotData(response.data);
            setFormData(response.data);
            return response?.data;

        } catch (error) {
            console.log("error occurred while api calling " + error);
        }
    }
    
    const fetchFacilityList = async () => {
        try {
            const response = await SupportApiService.getFacilityList();
            setFacilities(response?.data);
            return response?.data;

        } catch (error) {
            console.log("error occurred while api calling " + error);
        }
    }

    const addFacility = async () => {
    
        if (formData.facility != null) {
            const requestData = {
            facilityName: formData.facility,
            isActive: true,
            isDelete: false,
            };

            const response = await SupportApiService.addFacility(requestData);
            setFormData((prev: any) => ({...prev, facilityId: response?.data?.id}));
            return response?.data?.id;
        } else { 
            return null;
        }
    };

    const onSubmit = async (e: React.FormEvent) => {
        
        e.preventDefault();
        setIsLoading(true);

        const isFormValid = await validateRequireFields();

        if (!isFormValid) {
            setIsLoading(false);
            return;
        }

        let facilityId = formData?.facilityId;

        if (!facilityId) {
            facilityId = await addFacility();
        }
        // Processing Mash Bill to only include grains > 0%
        const processedMashBill = (formData?.mashBill || "")
            .split(",")
            .map((item: string) => item.trim())
            .filter((item: string) => {
                // Extracts the percentage value. E.g. "70% Corn" -> "70"
                const match = item.match(/^(\d+)%/);
                if (match) {
                    return parseInt(match[1], 10) > 0;
                }
                return item.length > 0; // Keep non-percentage items if they exist
            })
            .join(", ");
        const payload = { ...formData, facilityId, mashBill: processedMashBill, updateScope, representativeBarrelId: formData?.id };

        try {
            // CHECK BEFORE EDIT (ADDED)
            const response = await Service.fetchCustomerServiceRequestsLotLevelBarrel(formData?.companyId, formData?.lotNo);
            let isUsed = response.data;
            if (isUsed && !show) {
                handleShow();
                setIsLoading(false);
                return;
            }

            await InventoryApiService.editBarrelLotLevel(payload);

            CommonService.Toast.fire({
                title: "Container Updated Successfully",
                icon: "success",
            });
            history.goBack();
        } catch (error: any) {
            CommonService.Toast.fire({
                title: error.response.data.errorMessage,
                icon: "error",
            });
        } finally {
            setIsLoading(false);
        }
    };

function validateMashbill(input) {
  if (!input || String(input).trim().length === 0) {
    return { valid: false, error: "Mashbill cannot be empty" };
  }

  let clean = String(input)
    .toLowerCase()
    .replace(/,/g, " ")
    .replace(/%/g, "")
    .trim();

  // Handle leading company/brand words
  clean = clean.replace(/^[a-z\s]+(?=\d)/i, "").trim();

  // 1. Shortcut format (e.g. 70/20/10)
  if (/^[\d.]+(\s*\/\s*[\d.]+)+$/.test(clean)) {
    return { valid: true };
  }

  const tokens = clean.split(/\s+/);
  
  for (let i = 0; i < tokens.length; ) {
    const num = parseFloat(tokens[i]);
    
    if (isNaN(num)) {
      return { valid: false, error: `Invalid format near: "${tokens[i]}"` };
    }
    i++;

    // Capture the ingredient name (could be multiple words)
    const ingredientParts = [];
    while (i < tokens.length && isNaN(parseFloat(tokens[i]))) {
      ingredientParts.push(tokens[i]);
      i++;
    }

    // ERROR: Number exists but no name follows (e.g., "70% ")
    if (ingredientParts.length === 0) {
      return { valid: false, error: `Missing ingredient name after ${num}%` };
    }

    const ingredientName = ingredientParts.join("");
    // Accept any ingredient as long as it's at least 2 characters
    if (ingredientName.length < 2) {
      return { valid: false, error: `Please enter a valid ingredient name` };
    }
  }

  return { valid: true };
}

const handleMashBillChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  let value = e.target.value;

  // 1. If user totally removes the value, show prefill template
  if (value === "") {
    value = DEFAULT_MASH_BILL;
  }

  // 2. Update your existing form structure
  // This uses your existing 'handleChange' logic to update formData.mashBill
  handleChange({
    target: {
      name: "mashBill",
      value: value
    }
  } as any);

  // 3. Validation Logic
  // We only run validation if it's NOT the default template 
  // (to avoid showing "00 is not a number" errors immediately)
  if (value !== DEFAULT_MASH_BILL) {
    const result = validateMashbill(value);
    if (!result.valid) {
      setErrors((prev) => ({ ...prev, mashBill: result.error }));
    } else {
      setErrors((prev) => ({ ...prev, mashBill: "" }));
    }
  } else {
    // Clear errors if it's back to the template
    setErrors((prev) => ({ ...prev, mashBill: "" }));
  }
};
    return (
        <>
            <div className="add-company-user-wrapper usersList rounded-0 edit-barrels-wrapper">
                    <div className="usersList__header--wrapper d-flex flex-wrap align-items-center w-100">
                        <div className="d-flex align-items-center w-100 flex-wrap gap-2 position-relative">
                {CommonService.isAdmin() && (
                            <div className="d-flex align-items-center gap-2 flex-wrap left-wrapper">
                                <div className="back__button" onClick={routeBack}>
                                    <IconButton
                                        aria-label="ArrowBackIcon"
                                        sx={{ backgroundColor: "#FFF" }}
                                    >
                                        <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                                    </IconButton>
                                </div>

                                <div className="header--title">
                                    <h1 className="title mb-0">
                                        Edit Lot Details
                                    </h1>
                                </div>
                                <div className="divider mx-2"></div>
                            </div>
                        
                        )}
                    <div className="person__details me-3 me-xl-4 mb-0">
                        <Typography
                            variant="h6"
                            sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                        >
                            Lot ID
                        </Typography>
                        <Typography
                            variant="h3"
                            sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                        >
                            {formData?.lotNo}
                        </Typography>
                    </div>
                    </div>
                    </div>
                
                <div className="add-company-user-form-wrapper p-0">
                    <form
                        className="form__inner edit-inventory-form py-5 mx-auto"
                        onSubmit={onSubmit}
                        noValidate
                    >
                        <div className="row g-4">
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="lotNo" className="form-label">
                                    <strong>Lot No{" "}</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="lotNo"
                                    name="lotNo"
                                    placeholder="Enter lot no"
                                    value={formData?.lotNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={true}
                                    className={`form-control ${errors.lotNo ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.lotNo && (
                                    <div className="error-message">{errors.lotNo}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="fillDate" className="form-label">
                                    <strong>Fill Date</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    id="fillDate"
                                    name="fillDate"
                                    placeholder="Enter fill date"
                                    value={formData?.fillDate}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={true}
                                    className={`form-control ${errors.fillDate ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.fillDate && (
                                    <div className="error-message">{errors.fillDate}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="companyName" className="form-label">
                                    <strong>Company Name{" "}</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="companyName"
                                    name="companyName"
                                    placeholder="Enter Company name"
                                    value={formData?.companyName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={true}
                                    className={`form-control ${errors.companyName ? "is_invalid" : ""}`}
                                />
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="productName" className="form-label">
                                    <strong>Title{" "}</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="productName"
                                    name="productName"
                                    placeholder="Enter Title"
                                    value={formData?.productName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.productName ? "is_invalid" : ""}`}
                                />
                                {errors.productName && (
                                    <div className="error-message">{errors.productName}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="producer" className="form-label">
                                    <strong>Producer{" "}</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="producer"
                                    name="producer"
                                    placeholder="Enter producer"
                                    value={formData?.producer}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.producer ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.producer && (
                                    <div className="error-message">{errors.producer}</div>
                                )}
                            </div>
                             <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="dsp" className="form-label">
                                    <strong>Dsp{" "}</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="dsp"
                                    name="dsp"
                                    placeholder="Enter dsp"
                                    value={formData?.dsp}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.dsp ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.dsp && (
                                    <div className="error-message">{errors.dsp}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="facility" className="form-label">
                                    <strong>Facility{" "}</strong> <span className="star-required text-danger">*</span>
                                </label>
                                <CreatableSelect
                                    isClearable
                                    options={facilityOptions}
                                    value={
                                    formData?.facilityId
                                        ? { value: formData?.facilityId, label: formData?.facility }
                                        : formData?.facility
                                        ? { value: formData?.facility, label: formData?.facility }
                                        : null
                                    }
                                    onChange={(selected: any) => {
                                    if (selected) {
                                        setFormData((prev: any) => ({
                                        ...prev,
                                        facility: selected.label,
                                        facilityId: selected.value,
                                        }));
                                        // clear error immediately
                                        setErrors((prev: any) => {
                                            const updated = { ...prev };
                                            delete updated.facility;
                                            return updated;
                                        });
                                    } else {
                                        setFormData((prev: any) => ({
                                        ...prev,
                                        facility: "",
                                        facilityId: null
                                        }));
                                    }
                                    }}
                                    onCreateOption={(inputValue: string) => {
                                    // User typed a NEW facility
                                    setFormData((prev: any) => ({
                                        ...prev,
                                        facility: inputValue,
                                        facilityId: null, // indicate NEW
                                    }));
                                    }}
                                    placeholder="Select or create facility"
                                    isDisabled={true}
                                />

                                {errors.facility && (
                                    <div className="error-message">{errors.facility}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="mashBill" className="form-label">
                                    <strong>Mash Bill</strong> <span className="star-required text-danger">*
                                        <Tooltip title={
                                                                            <>
                                                                              Enter Mash Bill in the following format:
                                                                              <br />
                                                                              00% Ingredient Name, 00% Ingredient Name
                                                                              <br />
                                                                              Example:
                                                                              <br />
                                                                              20% Corn, 30% Rye, 40% Wheat, 10% Malted Barley
                                                                            </>
                                                                          }>
                                          <img src={InfoIcon} alt="Info" className="inline-block ms-2"/>
                                        </Tooltip>
                                        </span>
                                </label>
                                <input
                                    type="text"
                                    id="mashBill"
                                    name="mashBill"
                                    placeholder="Enter Mash bill"
                                    value={formData?.mashBill}
                                    onChange={handleMashBillChange}
                                    onBlur={handleBlur}
                                    onFocus={(e) => {
                                    // If the value is the template, auto-select it for easy replacement
                                    if (formData?.mashBill === DEFAULT_MASH_BILL) {
                                        e.target.select();
                                    }
                                    }}
                                    className={`form-control ${errors.mashBill ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.mashBill && (
                                    <div className="error-message">{errors.mashBill}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="proof" className="form-label">
                                    <strong>Proof{" "}</strong>
                                </label>
                                <input
                                    type="text"
                                    id="proof"
                                    name="proof"
                                    placeholder="Enter Proof"
                                    value={formData?.proof}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.proof ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.proof && (
                                    <div className="error-message">{errors.proof}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="proofGallons" className="form-label">
                                    <strong>Proof Gallons{" "}</strong>
                                </label>
                                <input
                                    type="text"
                                    id="proofGallons"
                                    name="proofGallons"
                                    placeholder="Enter Proof Gallons"
                                    value={formData?.proofGallons}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.proofGallons ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.proofGallons && (
                                    <div className="error-message">{errors.proofGallons}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="ttbType" className="form-label">
                                    <strong>TTB Type{" "}</strong>
                                </label>
                                <input
                                    type="text"
                                    id="ttbType"
                                    name="ttbType"
                                    placeholder="Enter TTB Type"
                                    value={formData?.ttbType}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.ttbType ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.ttbType && (
                                    <div className="error-message">{errors.ttbType}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="ttbClass" className="form-label">
                                    <strong>TTB Class{" "}</strong>
                                </label>
                                <input
                                    type="text"
                                    id="ttbClass"
                                    name="ttbClass"
                                    placeholder="Enter TTB Class"
                                    value={formData?.ttbClass}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control ${errors.ttbClass ? "is_invalid" : ""
                                    }`}
                                />
                                {errors.ttbClass && (
                                    <div className="error-message">{errors.ttbClass}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                <label htmlFor="barrelCost" className="form-label">
                                    <strong>Container Cost</strong>
                                </label>
                                <input
                                    type="text"
                                    id="barrelCost"
                                    placeholder="Enter Container Cost"
                                    name="barrelCost"
                                    value={formData?.barrelCost}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>
                            {formData?.containerType === "BARREL" && (
                                <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 position-relative mb-0">
                                    <label className="form-label">
                                    <strong>Container Condition</strong>
                                    </label>

                                    <div className="d-flex align-items-center gap-3 mt-1">
                                    <div className="form-check ps-0">
                                        <input
                                        className="form-check-input"
                                        type="radio"
                                        name="containerCooperage"
                                        id="container-cooperage-reused"
                                        value="REUSED"
                                        checked={formData?.containerCooperage === "REUSED"}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        />
                                        <label
                                        className="form-check-label"
                                        htmlFor="container-cooperage-reused"
                                        >
                                        Reused
                                        </label>
                                    </div>

                                    <div className="form-check">
                                        <input
                                        className="form-check-input"
                                        type="radio"
                                        name="containerCooperage"
                                        id="container-cooperage-new"
                                        value="NEW"
                                        checked={formData?.containerCooperage === "NEW"}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        />
                                        <label
                                        className="form-check-label"
                                        htmlFor="container-cooperage-new"
                                        >
                                        New
                                        </label>
                                    </div>
                                    </div>

                                    {errors.containerCooperage && (
                                    <div className="error-message">{errors.containerCooperage}</div>
                                    )}
                                </div>
                            )}

                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 mb-0">
                                <label htmlFor="isManagedByWhitedog" className="form-label">
                                    <strong>Whitedog Managed</strong>
                                </label>
                                <div className="d-flex align-items-center gap-3 mt-1">
                                    <div className="form-check ps-0">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="isManagedByWhitedog"
                                            id="isManagedByWhitedog-yes"
                                            checked={formData?.isManagedByWhitedog === true}
                                            onChange={() => setFormData({ ...formData, isManagedByWhitedog: true })}
                                        />
                                        <label className="form-check-label" htmlFor="isManagedByWhitedog-yes">Yes</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="isManagedByWhitedog"
                                            id="isManagedByWhitedog-no"
                                            checked={formData?.isManagedByWhitedog === false}
                                            onChange={() => setFormData({ ...formData, isManagedByWhitedog: false })}
                                        />
                                        <label className="form-check-label" htmlFor="isManagedByWhitedog-no">No</label>
                                    </div>
                                </div>
                                {errors.isManagedByWhitedog && (
                                    <div className="error-message">{errors.isManagedByWhitedog}</div>
                                )}
                            </div>

                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 mb-0">
                                <label htmlFor="description" className="form-label">
                                    <strong>Description </strong>
                                </label>

                                <textarea
                                    required
                                    className={`form-control ${errors.description ? "is_invalid" : ""}`}
                                    aria-label="With textarea"
                                    id="description"
                                    name="description"
                                    placeholder="Enter text here..."
                                    value={stripHtml(formData?.description)}
                                    onChange={handleChange}
                                    rows={4}
                                    maxLength={255}
                                    style={{ resize: "none" }}
                                />

                                <span className="text-length">
                                    {stripHtml(formData?.description)?.length ?? 0}/255
                                </span>

                                {errors.description && (
                                    <div className="error-message">{errors.description}</div>
                                )}
                            </div>
                            <div className="edit-barrels-form-group col-12 col-sm-6 col-lg-4 col-xl-3 mb-0">
                                <label htmlFor="mashBillDescription" className="form-label">
                                    <strong>Mashbill Description</strong>
                                </label>

                                <textarea
                                    required
                                    className={`form-control ${errors.mashBillDescription ? "is_invalid" : ""}`}
                                    aria-label="With textarea"
                                    id="mashBillDescription"
                                    name="mashBillDescription"
                                    placeholder="Enter text here..."
                                    value={stripHtml(formData?.mashBillDescription)}
                                    onChange={handleChange}
                                    rows={4}
                                    maxLength={255}
                                    style={{ resize: "none" }}
                                />

                                {errors.mashBillDescription && (
                                    <div className="error-message">{errors.mashBillDescription}</div>
                                )}
                            </div>
                            <div className="col-8 mb-2">
                                <label className="form-label">
                                    <strong>Update Scope</strong>
                                </label>
                                <div className="d-flex align-items-center gap-4 mt-1">
                                    <div className="form-check ps-0">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="updateScope"
                                            id="scope-whole-lot"
                                            checked={updateScope === "whole_lot"}
                                            onChange={() => setUpdateScope("whole_lot")}
                                        />
                                        <label className="form-check-label" htmlFor="scope-whole-lot">
                                            Update Whole Lot
                                            <small className="d-block text-muted" >
                                                Apply changes to all containers under lot <strong>{formData?.lotNo}</strong>
                                            </small>
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="updateScope"
                                            id="scope-matching"
                                            checked={updateScope === "matching_only"}
                                            onChange={() => setUpdateScope("matching_only")}
                                        />
                                        <label className="form-check-label" htmlFor="scope-matching">
                                            Update Matching Containers Only
                                            <small className="d-block text-muted">
                                                Only containers matching this lot's facility, producer, warehouse &amp; mash bill
                                            </small>
                                        </label>
                                    </div>
                                </div>
                            </div>                            
                            <div className="col-12">
                                <p className="form-info-msg">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM13.5 16.5C13.5 16.6989 13.421 16.8897 13.2803 17.0303C13.1397 17.171 12.9489 17.25 12.75 17.25C12.3522 17.25 11.9706 17.092 11.6893 16.8107C11.408 16.5294 11.25 16.1478 11.25 15.75V12C11.0511 12 10.8603 11.921 10.7197 11.7803C10.579 11.6397 10.5 11.4489 10.5 11.25C10.5 11.0511 10.579 10.8603 10.7197 10.7197C10.8603 10.579 11.0511 10.5 11.25 10.5C11.6478 10.5 12.0294 10.658 12.3107 10.9393C12.592 11.2206 12.75 11.6022 12.75 12V15.75C12.9489 15.75 13.1397 15.829 13.2803 15.9697C13.421 16.1103 13.5 16.3011 13.5 16.5ZM10.5 7.875C10.5 7.6525 10.566 7.43499 10.6896 7.24998C10.8132 7.06498 10.9889 6.92078 11.1945 6.83564C11.4001 6.75049 11.6263 6.72821 11.8445 6.77162C12.0627 6.81502 12.2632 6.92217 12.4205 7.0795C12.5778 7.23684 12.685 7.43729 12.7284 7.65552C12.7718 7.87375 12.7495 8.09995 12.6644 8.30552C12.5792 8.51109 12.435 8.68679 12.25 8.8104C12.065 8.93402 11.8475 9 11.625 9C11.3266 9 11.0405 8.88147 10.8295 8.6705C10.6185 8.45952 10.5 8.17337 10.5 7.875Z" fill="#3A809E" />
                                    </svg>
                                    <span>
                                        Submitting this form will apply the updated values to all containers in this lot for the corresponding fields.
                                    </span>
                                </p>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="form__btn--group">
                                <button
                                    type="button"
                                    onClick={routeBack}
                                    className="btn secondary-btn register-btn mb-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn primary-btn register-btn mb-2"
                                    disabled={isLoading}
                                >
                                    {isLoading && <Spinner />}
                                    {"Submit"}
                                </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Modal
                show={show}
                onHide={handleClose}
                className="modal__wd modal__wd--submitSellReq barrel-assignment-modal signup-success-modal"
                size="lg"
                centered
            >
                <Modal.Header className="align-items-center justify-content-between">
                    <Modal.Title className="modal-title">  Confirm Lot Details Update</Modal.Title>
                    <button onClick={handleClose} type="button" className="p-0 bg-transparent border-0 outline-0" data-bs-dismiss="modal" aria-label="Close">
                        <CloseIcon sx={{ color: "#ffffff" }} />
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <div className="form__inner scanned-popup-wrapper">
                        <div className="text-center">
                            <span className="warning-icon-wrapper mx-auto">
                                <img src={ScannedWarning} alt="Product Checkout icon" />
                            </span>
                        </div>
                        <h2 className="modal-body__title text-center">
                            Are You Sure You Want to Update This Lot?
                        </h2>
                        <p className="modal-text">
                            This Lot is currently associated with one or more active Sell or Service Requests.
                            Updating Lot details will automatically apply the changes to all conatiners under the update scope
                            and may impact active Marketplace listings, Service Requests, Inventory records,
                            and reporting data.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <div className="btn-group d-flex justify-content-center flex-wrap w-100 gap-3">
                        {/* <div className="col-6 ps-0"> */}
                        <button className="secondary-btn" onClick={handleClose} disabled={isLoading} style={{ minWidth: "190px" }}>
                            No
                        </button>
                        <button className="primary-btn" disabled={isLoading}
                            onClick={(e) => { handleClose(); onSubmit(e) }} style={{ minWidth: "190px" }}>
                            {isLoading && <Spinner />} Yes
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditLotDetails;